module.exports = __webpack_public_path__ + "img/floorMap.392467f9.png";